/**
 * Textbausteine, an denen aus Zahlen Sprache wird.
 *
 * **Warum das ins Designsystem gehört und nicht in jede Anwendung.** Eine
 * Oberfläche besteht nicht nur aus Farben und Abständen; „1 Vorgänge" fällt
 * einem Benutzer schneller auf als ein falscher Zeilenabstand, und es fällt
 * ihm in jeder der drei Anwendungen gleich auf.
 *
 * Der Anlass war dreimal derselbe Fehler an drei Stellen im Portal, und beim
 * Nachsehen ein vierter in der Betreiber-Konsole: „{lage.gesamt}
 * Kundenstacks". Fünf im Demostand, und deshalb nie aufgefallen — im Betrieb
 * gibt es heute **einen**.
 */

/**
 * Zahl mit Einzahl oder Mehrzahl — „1 Vorgang", „5 Vorgänge".
 *
 * Deutsch kennt mehr Fälle, als diese Funktion abdeckt: Genitiv, Dativ, „kein
 * Vorgang" statt „0 Vorgänge". Was die Oberflächen brauchen, ist der Nominativ
 * mit vorangestellter Zahl; mehr zu bauen hieße, eine Grammatikbibliothek
 * anzufangen, und die pflegt dann niemand.
 *
 * Das Verb darf mitgeführt werden — „1 Nachricht ist" gegen „7 Nachrichten
 * sind". Es gehört zur Zahl, nicht zum Satz drumherum, und wer es draußen
 * lässt, baut den Fehler eine Ebene höher wieder ein.
 */
export function mehrzahl(anzahl: number, einzahl: string, mehrzahl: string): string {
  return `${anzahl} ${anzahl === 1 ? einzahl : mehrzahl}`;
}
